module.exports = __webpack_public_path__ + "static/media/sakura.eadb5288.png";